import { useUserStore } from '../store/userStore'

export default ({ $fire, pinia }) => {
  $fire.auth.onAuthStateChanged((authUser) => {
    const userStore = useUserStore(pinia)

    if (!authUser) {
      userStore.setUser({ user: {} })
      userStore.setloggedIn(false)
    } else {
      const { uid, email, emailVerified, phoneNumber, role, auxRole } = authUser
      const typeProfile =
        role &&
        ['superadmin', 'admin', 'operator', 'editor', 'communicator'].includes(
          role
        )
          ? 'Funcionario'
          : auxRole && ['officer'].includes(auxRole)
          ? 'Funcionario'
          : 'Ciudadano'

      userStore.setUser({
        uid,
        email,
        emailVerified,
        phoneNumber,
        role,
        typeProfile,
      })
      userStore.setloggedIn(true)
    }
  })
}
